import graphql__6c70f52a4b8b45af35db from "./__generated__/UpdateProfileMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";
import { serializeUserFormValues } from "../components/Utils/serializeUserFormValues";

// Static fields that are always present in the form, allowing us to separate
// those fields from the one created in the admin panel when we serialize our
// form for the mutation
const staticFields = [
  "name",
  "email",
  "password",
  "passwordConfirmation",
  "emailConsent",
  "emailTrackingConsent"
];

const mutation = graphql__6c70f52a4b8b45af35db;

function updateProfile(form, onCompleted) {
  const variables = serializeUserFormValues(form, staticFields);

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { updateProfile };
